export interface CleanupAction {
  id: string;
  name: string;
  description: string;
  category: string;
  type: 'cleanup' | 'optimization';
  taskId: string;
  selectedAt: string;
}

export type TaskDomain = 'services' | 'escalation-policies' | 'incidents' | 'teams' | 'schedules' | 'integrations';

export interface CleanupTask {
  id: string;
  name: string;
  description: string;
  status: 'running' | 'pending' | 'done' | 'error';
  domain: TaskDomain;
  progress?: number;
  startedAt?: string;
  completedAt?: string;
}

export const DUMMY_ACTIONS: CleanupAction[] = [
  {
    id: 'action-1',
    name: 'Remove Unused Services',
    description: 'Delete services with no incidents in the last 90 days and no active integrations.',
    category: 'Services',
    type: 'cleanup',
    taskId: 'task-5',
    selectedAt: '2025-03-24T10:00:00Z',
  },
  {
    id: 'action-2',
    name: 'Consolidate Duplicate Teams',
    description: 'Merge teams with overlapping membership and similar escalation policies.',
    category: 'Teams',
    type: 'optimization',
    taskId: 'task-1',
    selectedAt: '2025-03-24T10:05:00Z',
  },
  {
    id: 'action-3',
    name: 'Archive Stale Schedules',
    description: 'Archive on-call schedules that have not been used in the last 60 days.',
    category: 'Schedules',
    type: 'cleanup',
    taskId: 'task-2',
    selectedAt: '2025-03-24T10:10:00Z',
  },
];

export const DUMMY_TASKS: CleanupTask[] = [
  {
    id: 'task-1',
    name: 'Analyzing Service Inventory',
    description: 'Scanning all services for usage metrics and health indicators.',
    status: 'running',
    domain: 'services',
    progress: 65,
    startedAt: '2025-03-24T10:15:00Z',
  },
  {
    id: 'task-2',
    name: 'Evaluate Escalation Policies',
    description: 'Checking escalation policies for gaps and redundancies.',
    status: 'pending',
    domain: 'escalation-policies',
  },
  {
    id: 'task-3',
    name: 'Scan Incident History',
    description: 'Reviewing incident patterns over the last 90 days.',
    status: 'done',
    domain: 'incidents',
    startedAt: '2025-03-24T09:00:00Z',
    completedAt: '2025-03-24T09:45:00Z',
  },
  {
    id: 'task-4',
    name: 'Map Team Ownership',
    description: 'Identifying services and schedules without clear team ownership.',
    status: 'done',
    domain: 'teams',
    startedAt: '2025-03-24T09:50:00Z',
    completedAt: '2025-03-24T10:10:00Z',
  },
  {
    id: 'task-5',
    name: 'Validate Integration Endpoints',
    description: 'Testing all active integration endpoints for connectivity.',
    status: 'error',
    domain: 'integrations',
    startedAt: '2025-03-24T10:12:00Z',
  },
];
